<template>
  <DialogComponent
    ref="dialog"
    type="fullscreen"
    noInnerPadding
    hideCloseButton
  >
    <MapLocationPickerV2
      :defaultPosition="defaultPosition"
      :additionalFields="additionalFields"
      :defaultValues="defaultValues"
      ref="selector"
      @location-selected="onLocationSelected"
      @back-clicked="dialog?.hide()"
    />
  </DialogComponent>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { bus } from '@core/events/eventSystem'
import constants from '@core/utils/constants'
import MapLocationPickerV2 from './MapLocationPickerV2.vue'

const dialog = ref(null)
const selector = ref(null)

const locationRequestKey = ref('')
const defaultPosition = ref(null)
const additionalFields = ref(null)
const defaultValues = ref(null)

const showDetails = ({ requestKey, defaultPosition: pos, additionalFields: fields, defaultValues: vals }) => {
  locationRequestKey.value = requestKey || ''
  defaultPosition.value = pos || null
  additionalFields.value = fields || null
  defaultValues.value = vals || null
  setTimeout(() => {
    dialog.value?.show()
  }, 300)
}

const onLocationSelected = (selectedLocation) => {
  bus.emit(constants.EVENTS.MAP.LOCATION_SELECTED, {
    requestKey: locationRequestKey.value,
    selectedLocation,
  })
  dialog.value?.hide()
}

let handlerId
onMounted(() => {
  handlerId = bus.on(constants.EVENTS.MAP.LOCATION_SELECTION_REQUIRED, showDetails)
})

onUnmounted(() => {
  if (handlerId) {
    bus.off(handlerId)
  }
})

defineExpose({
  showDetails,
})
</script>
